import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import chroma from 'chroma-js';
import { Observable } from 'rxjs';
import { mergeMap, map } from 'rxjs/operators';
import { BackendService, ColorService } from '@hub-components';

interface CreatePresignedUrlResponse {
  url: string
  public_url: string
  upload_secret: string
}

@Injectable(
  { providedIn: 'root' },
)
export class WysiwygService {
  fontSizes = ['8px', '9px', '10px', '11px', '12px', '14px', '18px', '24px', '28px', '30px', '32px', '36px', '48px', '60px', '72px', '96px'];

  get textColors() {
    const defaultColors = this.colorService.defaultColors.slice(0, 10).sort((a, b) => chroma(a).hsl()[0] - chroma(b).hsl()[0]);
    const colors = [];

    colors.push(...defaultColors.map(color => chroma(color).brighten(1).desaturate(0.25).hex()));
    colors.push(...defaultColors);
    colors.push(...defaultColors.map(color => chroma(color).darken(1.5).saturate(0.5).hex()));

    const grayscaleColors = [
      ...chroma.scale(['#FFFFF8', '#A6A6A0', '040400']).colors(10),
      ...chroma.scale(['#FFFFFF', '#A2A2A2', '#000000']).colors(10),
      ...chroma.scale(['#FAFCFF', '#A2A6AB', '#00060F']).colors(10),
    ].map(c => c.toUpperCase());

    colors.push(...grayscaleColors);

    return colors;
  }

  constructor(
    private backendService: BackendService,
    private colorService: ColorService,
    private http: HttpClient,
  ) {}

  uploadFile(file: File): Observable<CreatePresignedUrlResponse> {
    return this.backendService.create('/image/upload_url', { filename: file.name, filetype: file.type })
      .pipe(
        mergeMap((response: CreatePresignedUrlResponse) => {
          return this.doUpload(response.url, file).pipe(map(() => response));
        }),
      );
  }

  private doUpload(url: string, file: File) {
    let headers = new HttpHeaders();
    headers.set('Content-Type', file.type);
    return this.http.put(url, file, { headers });
  }
}
